// @ts-ignore
import type * as SchemaTypes from '../../../index';

import { gql } from 'graphql-tag';
export const GemsIntRangeFragmentDoc = gql`
    fragment gemsIntRange on GemsApi_IntRange {
  min
  max
}
    `;